import { Box, Container, TextField, Button, Typography, CircularProgress } from "@mui/material";
import React from "react";
import { apiBasicRequest } from "../services/apiClient";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
    const navigate = useNavigate();
    const [msg, setMsg] = React.useState();
    const [mail, setMail] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    
    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        apiBasicRequest('/user/forgot-password', {
            method: 'POST',
            body: JSON.stringify({mail}),
        }).then(async response => {
            setLoading(false);
            if (response.ok) {
                setMsg("Un email de réinitialisation a été envoyé à l'adresse indiquée. Vous allez être redirigé vers la page de connexion dans quelques secondes.");
                setTimeout(() => {
                    navigate('/login');
                }, 5000);
            }
        }).catch(error => {
            setLoading(false);
            setMsg("Une erreur est survenue. Veuillez réessayer plus tard.");
        });
    }

    const verifyEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', px: 2, py: 4 }}>
            <Box sx={{alignSelf:'start'}}>
                <Typography variant='h3' align='center' marginTop={2}>EVS pub CMS</Typography>
                <Typography variant='h6' align='center' marginTop={1}>Application de gestion des pubs et publications de l'EVS</Typography>
            </Box>

            <Container sx={{maxWidth: {xs: "xl", md:"lg", lg: "md"}, display: "flex", flexDirection: "column", justifyContent: "center"}} component={'form'} onSubmit={handleSubmit}>
                <Typography variant='h4' align='center' marginTop={2} color={'primary'}>Mot de passe oublié</Typography>
                <Typography variant='body1' align='center' marginTop={1}>Pour réinitialiser votre mot de passe, veuillez renseigner votre adresse email. Vous recevrez ensuite un email contenant un lien pour réinitialiser votre mot de passe.</Typography>
                <Typography variant='body1' align='center' marginTop={1}>Si vous ne recevez pas d'email, veuillez vérifier votre dossier de spam ou contacter votre administrateur.</Typography>
            
                <TextField fullWidth value={mail} onChange={e=>setMail(e.target.value)} label="Adresse email" name="email" type="email" autoComplete="email" sx={{ marginBottom: 2 }} />
                {msg && <Typography variant='body2' color='error' align='center' marginBottom={2}>{msg}</Typography>}
                <Button type="submit" disabled={!verifyEmail(mail) || loading} sx={{display: "inline-block", alignSelf: "center"}} variant="contained" color="primary">
                    {loading ? <CircularProgress size={24} /> : "Envoyer le lien"}
                </Button>
            </Container>
        </Box>
    );
}